import { ActionsUnion } from '../types';
import { createAction } from '../../utils/action';
import ActionTypes from '../actionTypes';
import { RestErrorResponse } from '../../types/response/RestErrorResponse';
import { UserInfo } from './types';

export const Actions = {
  getUserInfo: () => createAction(ActionTypes.GET_USER_INFO),
  getUserInfoSuccess: (userInfo: UserInfo) => createAction(ActionTypes.GET_USER_INFO_SUCCESS, userInfo),
  getUserInfoError: (error: RestErrorResponse) => createAction(ActionTypes.GET_USER_INFO_ERROR, error)
};

export type UserActions = ActionsUnion<typeof Actions>;
